<template>
    <div>
        微信浏览器
    </div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    mounted() {
    //    localStorage.setItem('PUBMEDSEARCHTOKEN','30f914ab9da49e5f73870f11e875d7b715de17cb')
    //    localStorage.setItem('PUMMEDSEARCHUSERNAME','相遇。')
    //    localStorage.setItem('PUMMEDSEARCHHEADIMG','http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIcHzURq1Bpx5CoKtWLXrtA9Amia1aPdZmYeeF1a0umfYMJwULTBKJkiafFRsdl4RajBOGuSRHIQCDw/132')
    },
}
</script>


// WEBPACK FOOTER //
// src/components/weixin.vue